import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { UsersService } from '@smatchy/sdk';
import { firstValueFrom } from 'rxjs';
import { RemoveLocationAccessAction } from '../../app/state/user-location-access.action';

export type UserLocationAccessStateModel = object;

const defaults: UserLocationAccessStateModel = {};

@State<UserLocationAccessStateModel>({
  name: 'userLocationAccess',
  defaults,
})
@Injectable()
export class UserLocationAccessState {
  constructor(private readonly userService: UsersService) {}

  @Action(RemoveLocationAccessAction)
  async removeLocationAccessAction(
    _ctx: StateContext<UserLocationAccessStateModel>,
  ) {
    try {
      await firstValueFrom(this.userService.removeLocationAccess());
    } catch {
      console.log('location access has removed');
    }
  }
}
